module.exports = __webpack_public_path__ + "img/logo_alt.a8a05890.png";